import { render, staticRenderFns } from "./FlagBadge.vue?vue&type=template&id=28c13591&scoped=true"
import script from "./FlagBadge.vue?vue&type=script&lang=js"
export * from "./FlagBadge.vue?vue&type=script&lang=js"
import style0 from "./FlagBadge.vue?vue&type=style&index=0&id=28c13591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c13591",
  null
  
)

export default component.exports